import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { customReportsPropTypes } from './propTypes';

import AgGrid from '../../shared/agGrid/agGrid.component';

import columnDefs, { adminColumn, customFlagColumn } from './columnDefinitions';

class CustomReportsGrid extends PureComponent {
  static propTypes = {
    customReports: customReportsPropTypes,
    shouldDisplayAdminColumn: PropTypes.bool.isRequired,
    componentToRenderOnSearchBar: PropTypes.node,
    onCustomReportsGridReady: PropTypes.func.isRequired,
    changeDisplayFlag: PropTypes.func.isRequired,

    currentlySelectedCustomReportId: PropTypes.string,
    showCustomReportsFormForView: PropTypes.func.isRequired,
    isCustomReportQueryModified: PropTypes.bool.isRequired,
    isGridLoading: PropTypes.bool.isRequired,
    customReportToEditId: PropTypes.string,
  };

  componentDidUpdate(prevProps) {
    const { customReportToEditId, customReports } = this.props;

    if (customReportToEditId && prevProps.customReports !== customReports) {
      this.api.forEachNode(node => {
        if (node.data.reportSetId === customReportToEditId) {
          node.setSelected(true, true);
          this.api.ensureNodeVisible(node);
        }
      });
    }
  }

  onGridReady = params => {
    this.api = params.api;
    this.props.onCustomReportsGridReady(params);
  };

  onRowClicked = event => {
    const {
      showCustomReportsFormForView,
      isCustomReportQueryModified,
      currentlySelectedCustomReportId,
    } = this.props;
    const clickedRowCustomReportId = event.data.reportSetId;

    if (isCustomReportQueryModified) {
      this.api.forEachNode(node => {
        if (node.data.reportSetId === currentlySelectedCustomReportId && !node.data.selected) {
          node.setSelected(true);
        }
      });
      return;
    }

    showCustomReportsFormForView(clickedRowCustomReportId);
  };

  render() {
    const {
      customReports,
      changeDisplayFlag,
      shouldDisplayAdminColumn,
      componentToRenderOnSearchBar,
      isGridLoading,
    } = this.props;

    const columnDefsWithFlag = [...columnDefs, customFlagColumn(changeDisplayFlag)];

    return (
      <div className="queries-grid page-content-container">
        <AgGrid
          componentToRenderOnSearchBar={componentToRenderOnSearchBar}
          columnDefs={shouldDisplayAdminColumn ? [adminColumn].concat(columnDefsWithFlag) : columnDefsWithFlag}
          rowData={customReports}
          onGridReady={this.onGridReady}
          onRowClicked={this.onRowClicked}
          withSearchBar
          isGridLoading={isGridLoading}
        />
      </div>
    );
  }
}

export default CustomReportsGrid;
